import { WALLET_ERRORS } from '../constants/api'
import { formatValidator } from './validation.helpers'

const isWalletConnected = ({
  mounted,
  authenticationStatus,
  account,
  chain
}) => {
  const ready = mounted && authenticationStatus !== 'loading'
  return (
    ready &&
    account &&
    chain &&
    (!authenticationStatus || authenticationStatus === 'authenticated')
  )
}

const WALLET_ACCOUNT_STATUS = {
  CONNECTED: 'connected'
}

const buildTransactionErrorMessage = (message) => {
  return formatValidator(
    message === WALLET_ERRORS.USER_REJECTED_REQUEST
      ? 'home.rejected-transaction-request'
      : message || 'home.something-went-wrong'
  )
}

export {
  isWalletConnected,
  WALLET_ACCOUNT_STATUS,
  buildTransactionErrorMessage
}
